module.exports = __webpack_public_path__ + "img/IMG_1156_L_Black_MockedUp.8f4d4718.jpg";